class WorkoutScalingOption {
  constructor({ title = '', exercises = [] }) {
    this.title = title;
    this.exercises = exercises;
  }
}

export default WorkoutScalingOption;
